
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { AuthLayout, Form, TextInput } from '@app/components';
import { nextAuthOptions } from '@app/lib/server';
import { Button, Text } from '@mantine/core';
import { useForm, zodResolver } from '@mantine/form';
import { IconSend } from '@tabler/icons-react';
import { type GetServerSideProps, type NextPage } from 'next';
import { useRouter } from 'next/router';
import { type Session } from 'next-auth';
import { getServerSession } from 'next-auth/next';
import { signIn } from 'next-auth/react';
import { useState } from 'react';
import { z } from 'zod';
const schema = z.object({
    email: z.string().email()
});
interface RequestLinkFormData {
    email: string;
}
interface RequestLinkPageQueryParams {
    callbackUrl?: string;
}
const RequestLinkPage: NextPage = () => {
    const router = useRouter();
    const { callbackUrl = '/' }: RequestLinkPageQueryParams = router.query;
    const [isRequestingLink, setIsRequestingLink] = useState(false);
    const form = useForm<RequestLinkFormData>({
        initialValues: {
            email: ''
        },
        validate: zodResolver(schema)
    });
    return (<AuthLayout loading={isRequestingLink} title='Request Link'>
      <Text color='dimmed' mb='lg'>
        Enter your email below to be sent link to login with.
      </Text>
      <Form buttons={<Button color='blue' disabled={isRequestingLink} fullWidth leftIcon={<IconSend size={18}/>} type='submit'>
            Send Link
          </Button>} onSubmit={form.onSubmit(async (values) => {
            setIsRequestingLink(true);
            const { url } = await signIn('email', {
                ...values,
                callbackUrl,
                redirect: false
            });
            await router.push(url);
        })}>
        <TextInput autoComplete='email' disabled={isRequestingLink} icon={null} mb='lg' placeholder='Enter Your Email' required type='email' {...form.getInputProps('email')}/>
      </Form>
    </AuthLayout>);
};
const getServerSideProps: GetServerSideProps<{
    session: Session;
}> = async ({ req, res }) => {
    const session = await getServerSession(req, res, nextAuthOptions);
    if (session?.user?.id) {
        return {
            redirect: {
                destination: req.headers.referer || '/',
                permanent: false
            }
        };
    }
    return {
        props: {
            session
        }
    };
};
// noinspection JSUnusedGlobalSymbols
export default RequestLinkPage;

    async function __Next_Translate__getServerSideProps__18a3e4c7c3b__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/auth/request-link',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__18a3e4c7c3b__ as getServerSideProps }
  